import type { ApiResponse } from "@/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import type { DockmasterSpan } from "../../../schemas/codegen";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export type Trace = {
  traceId: string;
  spans: DockmasterSpan[];
};

export type TracesResponse = {
  traces: Trace[];
};

export function getTracesQueryOptions(projectId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.TRACES, projectId],
    queryFn: () => api.getTraces(projectId),
  });
}

export function useTraces(projectId: string) {
  return useQuery<ApiResponse<TracesResponse>, Error, TracesResponse>({
    queryKey: [QUERY_KEYS.TRACES, projectId],
    queryFn: () => api.getTraces(projectId),
    enabled: !!projectId,
    select: (response) => response.data,
    refetchInterval: 5000,
  });
}
